import {setupIncludedInCatalogue} from '../../common/included-in-catalogue';
import {runOnce} from '../../common/run-once';
import {documentReady} from '../../document-ready';

runOnce('helper-included-in-catalogue', () => {
    documentReady().then(() => {
        setupIncludedInCatalogue();
    });
});
